<template>
	<div class="orderList ">
		<div class="flex items-center justify-between pb-[6px] bB-03">
			<div class="flex items-center">
				<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
					:class="payment_status==item.status?'active text-[#FF0000] font-bold':'text-[#101010]'"
					class="navTitle cursor-pointer text-[16px]  relative text-[16px] mr-[34px]">
					{{item.title}}
				</div>
			</div>
		</div>

		<div class="" v-if="isFinish&&orderList.length>0">
			<div class="mb-[16px]">
				<div class="p-[18px] box-border orderItem" v-for="(item,index) in orderList" :key="index">
					<div
						class="h-[40px] mb-[20px] leading-[40px] flex items-center justify-between bg-[#F5F5F5] text-[16px] text-[#A6A6A6] px-[10px] box-border">
						<div class="flex items-center">
							<label class="mr-[16px]">{{langInfo['Order Number']}}：{{item.order_no}}</label>
							<label>{{langInfo['Order Time']}}: {{item.create_time}}</label>
						</div>

						<label class="fC-38" v-if="item.payment_status==0">{{langInfo['Waiting payment']}}</label>
						<label class="fC-38"
							v-else-if="item.payment_status==1&&item.invoice_info && item.invoice_info.status==0">{{langInfo['Invoice_progress']}}</label>
						<label class="fC-38"
							v-else-if="item.payment_status==1&&item.invoice_info && item.invoice_info.status==1">{{langInfo['invoice_issued']}}</label>
						<label class="fC-33"
							v-else-if="item.payment_status!=0">{{langInfo['Payment method']}}:{{item.payment_type_text}}</label>
					</div>
					<div class="flex  justify-between">
						<div class="flex  w-[420px] mr-[24px]">
							<el-image class="w-[120px] h-[80px] mr-[14px] rounded-[6px]"
								:src="item.product_info.cover_img" fit="cover"></el-image>
							<div class="flex-1">
								<div class="yw-text-cut-2 text-[14px] text-[#545C63]">
									{{item.product_info.name}}
								</div>
								<div class="text-[14px] text-[#A6A6A6]">
									{{item.product_info.category_info.name}}
								</div>
								<div class="text-[16px] text-[#FF0000]">
									¥{{item.total_amount}}
								</div>
							</div>
						</div>
						<div :class="item.status!='1'?'bL-01':''"
							class="flex-1 mr-[20px]  pl-[14px] pr-[36px] box-border">
							<div v-if="item.payment_status==0"
								class="text-[20px] text-[#3894FF] flex items-center justify-end h-full">
								{{langInfo['Waiting payment']}}
							</div>
							<div v-if="item.payment_status==1"
								class="text-[16px] text-[#A6A6A6] flex items-center justify-between h-full">
								<label> <label
										v-if="item.expire_time">{{langInfo['Expiration time']}}：{{item.expire_time}}</label>
								</label>
								<label v-if="item.payment_status==1&&item.is_expired==1">{{langInfo.Expired}}</label>
								<label
									v-if="item.invoice_info && item.invoice_info.status==0">{{langInfo.Under_issuance}}</label>
								<label
									v-if="item.invoice_info && item.invoice_info.status==1">{{langInfo.Issued}}</label>
							</div>
						</div>
						<div class="pl-[20px] box-border" style="border-left: 1px solid #D1D1D1;">
							<div @click="continuePay(item,index)" v-if="item.payment_status==0"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer mb-[16px] leading-[30px] text-center text-[#FCD53F]  text-[14px] rounded-[4px] border border-solid border-[#FCD53F]">
								{{langInfo.continue_pay}}
							</div>
							<div @click="cancelPay(item,index)" v-if="item.payment_status==0"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer leading-[30px] text-center text-white bg-[#FF0000] text-[14px] rounded-[4px]">
								{{langInfo.cancel_pay}}
							</div>
							<div @click="goStudyCenter()" v-if="item.payment_status==1&&item.is_expired==0"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer mb-[16px] leading-[30px] text-center text-[#FCD53F]  text-[14px] rounded-[4px] border border-solid border-[#FCD53F]">
								{{langInfo.enter_learn}}
							</div>
							<div @click="purchaseAgain(item,index)" v-if="item.payment_status==1&&item.is_expired==1"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer mb-[16px] leading-[30px] text-center text-[#A6A6A6]  text-[14px] rounded-[4px] border border-solid border-[#A6A6A6]">
								{{langInfo.PurchaseAgain}}
							</div>
							<div @click="applyExtension(item,index)" v-if="item.payment_status==1&&item.is_expired==1"
								class="min-w-[80px] h-[30px] px-[10px] box-border  cursor-pointer leading-[30px] text-center text-[#A6A6A6]  text-[14px] rounded-[4px] border border-solid border-[#A6A6A6]">
								{{langInfo['Apply Extension']}}
							</div>
							<div @click="applyInvoicing(item,index)"
								v-if="item.payment_status==1 && !item.invoice_info&&item.is_expired==0"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer leading-[30px] text-center text-white bg-[#3894FF] text-[14px] rounded-[4px]">
								{{langInfo['Apply Invoicing']}}
							</div>
							<div @click="viewTicket(item,index)"
								v-if="item.payment_status==1&& item.invoice_info && item.invoice_info.status==1"
								class="min-w-[80px] h-[30px] px-[10px] box-border cursor-pointer leading-[30px] text-center text-white bg-[#3894FF] text-[14px] rounded-[4px]">
								{{langInfo['View Ticket']}}
							</div>
						</div>

					</div>
				</div>

			</div>

			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<emptyPage v-else-if="isFinish&&orderList.length==0" :title="langInfo.no_data_available">
		</emptyPage>


		<!-- 收银台 -->
		<el-dialog :title="langInfo.checkstand" :visible.sync="payVisible" @close="closeDialog"
			:close-on-click-modal="false" width="40%" top="8vh" center>
			<div class="bg-white mb-[10px] py-[20px] px-[16px] box-border flex justify-between items-center">
				<div class="flex-1 flex mr-[80px]">
					<el-image class="w-[147px] h-[96px] mr-[16px] rounded-[6px]" :src="product_info.cover_img"
						fit="cover"></el-image>
					<div class="flex-1 ">
						<div class="mb-[10px]">
							{{product_info.name}}
						</div>
						<div class="text-[#999999]">
							x1
						</div>
					</div>
				</div>
				<div class="text-[20px] text-[#FF0000]">
					¥{{pay_amount}}
				</div>
			</div>
			<div class="bg-white mb-[10px]  flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px]  font-bold">
					{{langInfo['Remarks (Optional)']}}：
				</div>
				<div class="flex-1">
					<input v-model="payInfo.remarks" class="formInput w-full text-[18px]" type="text"
						:placeholder="langInfo.enter_remarks_tip" />
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo.coupon_title}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.couponCode" @change="couponChange" class="formInput w-full text-[18px]"
						:placeholder="langInfo.enter_coupon_tip"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[10px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] font-bold">
					{{langInfo['Invitation Code']}}：
				</div>
				<div class="flex-1">
					<el-input v-model="payInfo.invitationCode" @change="inviteCodeChange"
						class="formInput w-full text-[18px]" :placeholder="langInfo['enter_invitation_tip']"></el-input>
				</div>
			</div>
			<div class="bg-white mb-[20px] flex items-center py-[12px] px-[16px] box-border">
				<div class="text-[18px] flex items-center mr-[50px]">
					<label class="font-bold">{{langInfo['Balance deduction']}}</label> <label
						class="text-[16px] text-[#686C73]">（{{langInfo.account_balance}}：{{userInfo.money}}）</label>：
				</div>
				<div class="flex-1 flex align-items-center">
					<div class="flex items-center cursor-pointer mr-[40px]" @click="balanceClick(1)">
						{{langInfo.balance_yes}} <img class="w-[22px] h-[22px] ml-[10px] "
							:src="isBalance==1?selectedImg:selectImg" alt="" srcset="" />
					</div>
					<div class="flex items-center cursor-pointer" @click="balanceClick(2)">
						{{langInfo.balance_no}} <img class="w-[22px] h-[22px] ml-[10px]"
							:src="isBalance==2?selectedImg:selectImg" alt="" srcset="" />
					</div>
				</div>
			</div>
			<div class="text-[18px] flex items-center mb-[20px]">
				<label class="font-bold">{{langInfo['Actual amount']}}</label> <label
					class="text-[16px] ml-[18px] text-[#FF0000]">¥{{pay_price}}</label>
			</div>
			<div class="text-[18px] font-bold mb-[14px]">
				{{langInfo['Payment method']}}
			</div>
			<div class="mb-[24px] flex items-center ">
				<!-- <div @click="payMethod=5" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==5?selectedImg:selectImg" alt=""
						srcset="" />
					<label class="text-[#000C16] text-[16px]">{{langInfo['Offline pay']}}</label>
				</div> -->
				<div @click="payMethod=2" class="flex  items-center cursor-pointer  mr-[40px]">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==2?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index08.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
				<div @click="payMethod=1" class="flex  items-center cursor-pointer">
					<img class="w-[22px] h-[22px]  mr-[10px]" :src="payMethod==1?selectedImg:selectImg" alt=""
						srcset="" />
					<img src="@/static/image/index09.png" class="w-[110px] h-[40px]" alt="" srcset="" />
				</div>
			</div>
			<div @click="nextPay()"
				class="w-[250px] h-[44px]  cursor-pointer mx-auto leading-[44px] text-center text-[#ffffff] rounded-[4px] bg-[#FF0000] ">
				{{langInfo['Next step']}}
			</div>
		</el-dialog>

		<!-- 申请发票 -->
		<el-dialog :title="langInfo.ApplyInvoice" @close="applyClose" :visible.sync="applyVisible"
			:close-on-click-modal="false" width="50%" center>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
				<el-form-item :label="langInfo['Enterprise name']" prop="enterprise_name">
					<el-input v-model="ruleForm.enterprise_name"
						:placeholder="langInfo.enter_enterprise_name_tip"></el-input>
				</el-form-item>
				<el-form-item :label="langInfo['Tax number']" prop="tax_number">
					<el-input v-model="ruleForm.tax_number" :placeholder="langInfo.enter_tax_number_tip"></el-input>
				</el-form-item>
				<el-form-item :label="langInfo.Remarks" prop="remarks">
					<el-input v-model="ruleForm.remarks" :placeholder="langInfo.apply_enter_remarks_tip"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="applyClose()">{{langInfo.cancel}}</el-button>
					<el-button type="primary" @click="submitForm('ruleForm')">{{langInfo.submit}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 申请发票 -->

		<!-- 申请延期 -->
		<el-dialog title="" @close="extensionClose" :visible.sync="extensionVisible" :close-on-click-modal="false">
			<div class="flex flex-col items-center">
				<div class="text-[#000C16] text-[20px] font-bold mb-[20px]">
					{{langInfo['Contact us']}}
				</div>
				<el-image class="w-[200px] h-[200px] " :src="official_weChat" fit="cover"></el-image>
			</div>
		</el-dialog>
		<!-- 申请延期 -->

		<el-dialog title="微信支付" @close="closeWxDialog" :visible.sync="wxPay" :close-on-click-modal="false" width="40%"
			center top="8vh">
			<div class="w-[250px] h-[250px]   mx-auto  rounded-[4px]  ">
				<img :src="qrcode" class="w-[250px] h-[250px] " alt="" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			emptyPage
		},
		name: "orderList",
		data() {
			return {
				payment_status: 'all', //订单类型:0=全部,1=待支付,2=已支付,3=已取消  
				navList: [{
						title: '', //所有订单
						status: "all"
					},
					{
						title: '', //待支付订单
						status: "0"
					},
					{
						title: '', //已完成订单
						status: "1"
					}
				],
				isFinish: false,
				page: 1,
				limit: 6,
				orderList: [],
				total: 0,
				payVisible: false,

				selectImg: require('@/static/image/icon68.png'),
				selectedImg: require('@/static/image/icon69.png'),
				payMethod: 2, //支付类型:1=微信,2=支付宝,4=余额 , 5=线下支付


				langInfo: {},
				orderInfo: {

					order_no: "",
					pay_order_id: 0,
					total_amount: 0
				},
				isBalance: 1,

				product_info: {
					name: "",
					cover_img: ''
				},
				pay_amount: '0.00',
				payInfo: {
					remarks: '', //备注，
					couponCode: '', //优惠券码
					invitationCode: '', //邀请码
				},
				userInfo: {
					money: ''
				},
				pay_price: '0.00',

				// 申请发票
				applyVisible: false,
				ruleForm: {
					enterprise_name: '',
					tax_number: '',
					remarks: ""
				},
				rules: {
					enterprise_name: [
						{ required: true, message: '', trigger: 'blur' } //请输入企业名称
					],
					tax_number: [{
						required: true,
						message: '', //请输入税号
						trigger: 'blur'
					}]
				},
				select_order_id: "",
				pay_order_id: "", //继续支付的订单号
				official_weChat: '',
				extensionVisible: false,

				qrcode: '',
				wxPay: false,
				jieguo: null,
				order_id: '',
				isAlipay:false

			}
		},

		mounted() {
			clearInterval(this.jieguo)
			this.getdict_data()
			this.getUserInfo()
			this.get_config()
		},
		destroyed() {
			clearInterval(this.jieguo)
			this.jieguo = null
		},
		methods: {
			setNav() {
				this.navList[0].title = this.langInfo['All orders']
				this.navList[1].title = this.langInfo['Order to be paid']
				this.navList[2].title = this.langInfo['Completed orders']
				this.rules.enterprise_name[0].message = this.langInfo.enter_enterprise_name_tip
				this.rules.tax_number[0].message = this.langInfo.enter_tax_number_tip

			},
			get_config() {
				this.$api.config({}).then((res) => {
					console.log(res);
					this.official_weChat = res.data.official_weChat

				}).catch((error) => {})
			},
			currentChange(e) {
				console.log(e);
				this.page = e
				this.isFinish = false
				this.order_list()
			},
			order_list() {
				this.$api.order_list({
					page: this.page,
					limit: this.limit,
					payment_status: this.payment_status
				}).then((res) => {
					console.log("订单列表====");
					console.log(res);
					this.orderList = res.data.list
					this.total = res.data.total
					this.isFinish = true
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			navClick(item, index) {
				this.payment_status = item.status
				this.page = 1
				this.orderList = []
				this.isFinish = false
				this.order_list()

			},
			getUserInfo() {
				this.$api.user_info().then((res) => {
					console.log(res.data);
					this.userInfo = res.data
					this.order_list()
				}).catch((error) => {
					if (error.code == 450) {
						setTimeout(() => {
							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);
							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title = this.langInfo.pc_name + '-' + this.langInfo.study_my_order

					this.setNav()
				}).catch((error) => {})
			},
			// 继续支付
			continuePay(item, index) {
				this.payVisible = true
				this.product_info = item.product_info
				this.pay_amount = item.pay_amount
				this.order_id = item.id
				this.$api.createPayOrder({
					order_id: item.id,
				}).then((res) => {
					this.pay_order_id = res.data.pay_order_id
					this.calculateAmount()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			balanceClick(type) {
				console.log(type);
				this.isBalance = type
				this.calculateAmount()
			},
			calculateAmount() {
				this.$api.calculateAmount({
					pay_order_id: this.pay_order_id,
					is_pay_money: this.isBalance,
					coupon: this.payInfo.couponCode,
					invitation_code: this.payInfo.invitationCode
				}).then((res) => {
					console.log(res);
					this.pay_price = res.data.pay_price
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 优惠券
			couponChange(e) {
				console.log(e);
				this.payInfo.couponCode = e
				this.calculateAmount()
			},
			// 邀请码
			inviteCodeChange(e) {
				this.payInfo.invitationCode = e
				this.calculateAmount()
			},
			nextPay() {
				if (this.payMethod == 5) {
					// 线下支付
					console.log("线下支付");
					this.$api.pay({
						payment: "pc",
						pay_order_id: this.pay_order_id,
						payment_type: this.payMethod,
						is_pay_money: this.isBalance,
						coupon: this.payInfo.couponCode,
						invitation_code: this.payInfo.invitationCode
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'success'
						})
						this.payVisible = false
						
						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 900)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {

					if (this.isBalance == 1 && this.pay_price == 0) {
						this.$api.pay({
							payment: "pc",
							pay_order_id: this.pay_order_id,
							payment_type: this.payMethod,
							is_pay_money: this.isBalance,
							coupon: this.payInfo.couponCode,
							invitation_code: this.payInfo.invitationCode
						}).then((res) => {
							console.log(res);
							this.$message({
								message: this.langInfo['Payment successful'] ,
								type: 'success'
							})
							this.payVisible = false
							
							setTimeout(() => {
								this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
							}, 900)
						}).catch((error) => {

							this.$message({
								message: error.msg,
								type: 'warning'
							})

							this.payVisible = false
						})
					} else {
						if (this.payMethod == 1) {
							this.$api.pay({
								payment: "pc",
								pay_order_id: this.pay_order_id,
								payment_type: this.payMethod,
								is_pay_money: this.isBalance,
								coupon: this.payInfo.couponCode,
								invitation_code: this.payInfo.invitationCode
							}).then((res) => {
								console.log(res);
								this.qrcode = res.data.qrcode
								this.wxPay = true
								this.payVisible = false

								this.jieguo = setInterval(() => {
									this.getOrderDetail()
								}, 2000)

							}).catch((error) => {
								this.payVisible = false
							})

						} else {
							this.isAlipay = true
						
							let payLocation =
								'https://app.51exampass.comapi/v1.pay/pay?server=1&payment=pc&pay_order_id=' + this
								.pay_order_id + '&payment_type=' + this.payMethod + '&is_pay_money=' + this.isBalance +
								'&coupon=' + this.payInfo.couponCode + '&invitation_code=' + this.payInfo.invitationCode +
								'&user_token=' +
								localStorage.getItem('token')

							window.open(payLocation, '_blank')
							
							
							
							this.jieguo = setInterval(() => {
								this.getOrderDetail()
							}, 2000)


							// this.payInfo = {
							// 	remarks: '', //备注，
							// 	couponCode: '', //优惠券码
							// 	invitationCode: '', //邀请码
							// 	pay_money: '' //余额抵扣
							// }
							// this.payVisible = false
						}
					}
				}

			},
			closeDialog() {
				if (this.payMethod == 2 && this.isBalance == 2 && this.isAlipay) {

					this.payInfo = {
						remarks: '', //备注，
						couponCode: '', //优惠券码
						invitationCode: '', //邀请码
						pay_money: '' //余额抵扣
					}
					this.payVisible = false

					this.isAlipay = false

					this.$api.order_detail({
						id: this.order_id,
					}).then((res) => {
						console.log(res.data);
						if (res.data.payment_status == 1) {
							this.$message({
								message: this.langInfo['Payment successful'] ,
								type: 'success'
							})
						} else {
							this.$message({
								message: this.langInfo['Payment failed'],
								type: 'success'
							})
						}
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				} else {
					this.payInfo = {
						remarks: '', //备注，
						couponCode: '', //优惠券码
						invitationCode: '', //邀请码
						pay_money: '' //余额抵扣
					}
					this.payVisible = false
				}

			},

			getOrderDetail() {
				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status == 1) {

						this.order_id = ""
						// 已支付
						this.wxPay = false
						clearInterval(this.jieguo)
						this.jieguo = null
						this.$message({
							message: this.langInfo['Payment successful'],
							type: 'success'
						})
						
						setTimeout(() => {
							this.$router.push('/studyCenter/newStudyCenter'); // 使用完整路径
						}, 900)
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			closeWxDialog() {
				clearInterval(this.jieguo)
				this.jieguo = null

				this.$api.order_detail({
					id: this.order_id,
				}).then((res) => {
					console.log(res.data);
					if (res.data.payment_status != 1) {
						this.$message({
							message: this.langInfo['Payment failed'],
							type: 'success'
						})
						this.order_id = ""
						this.qrcode = ''
						this.wxPay = false;
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			// 取消支付
			cancelPay(item, index) {
				this.$confirm(this.langInfo.delete_order_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'warning'
				}).then(() => {
					this.$api.cancelUnpaidOrder({
						order_id: item.id
					}).then((res) => {
						this.order_list()
					}).catch((error) => {})
				}).catch(() => {});
			},
			// 进入学习
			goStudyCenter() {
				this.$router.push('/studyCenter/newStudyCenter');
			},

			// 再次购买
			purchaseAgain(item, index) {
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.product_info.id
					}
				}); // 使用完整路径
			},
			// 申请延期
			applyExtension(item, index) {
				this.extensionVisible = true
			},
			extensionClose() {
				this.extensionVisible = false
			},

			// 申请开票

			applyInvoicing(item, index) {
				this.select_order_id = item.id
				this.applyVisible = true
			},
			applyClose() {
				this.applyVisible = false
				this.ruleForm.enterprise_name = ""
				this.ruleForm.tax_number = ""
				this.ruleForm.remarks = ""
				this.select_order_id = ""
			},
			submitForm(formName) {
				var that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {

						that.$api.add_invoice({
							name: that.ruleForm.enterprise_name,
							tax_id: that.ruleForm.tax_number,
							remarks: that.ruleForm.remarks,
							order_id: that.select_order_id
						}).then((res) => {
							console.log(res);
							this.$message({
								message: res.msg,
								type: 'success'
							})
							that.order_list()
						}).catch((error) => {
							this.$message({
								message: error.msg,
								type: 'warning'
							})
						})

						setTimeout(() => {
							this.applyVisible = false
							this.ruleForm.enterprise_name = ""
							this.ruleForm.tax_number = ""
							this.ruleForm.remarks = ""
							this.select_order_id = ""
						}, 800)
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			// 查看票据
			viewTicket(item, index) {
				window.open(item.invoice_info.file, '_blank')
			}
		}
	};
</script>

<style scoped>
	.formInput {
		border: none;
		background-color: transparent;
	}

	.formInput::placeholder {
		color: #A6A6A6;
		/* 例如，设置为灰色 */
	}

	/deep/.el-input__inner {
		border: 0;
	}

	/deep/.el-input__inner::placeholder {
		color: #b8b8b8;
	}

	/deep/.el-dialog--center {
		background-color: #F9F9F9;
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}

	.orderItem {
		border-bottom: 1px solid rgba(209, 209, 209, 1);
	}
</style>